import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@material-ui/core';
import React from 'react';
import {
  BackgroundProps,
  FontSizeProps,
  HeightProps,
  WidthProps,
  height,
  maxHeight,
  maxWidth,
  width,
} from 'styled-system';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export type FormControlLabelProps = MuiFormControlLabelProps &
  WidthProps &
  FontSizeProps &
  BackgroundProps &
  HeightProps & {
    label: string;
    showBorder?: boolean;
    checked?: boolean | string;
    disabled?: boolean;
    fontSize?: string;
  };

export function FormControlLabel({ control, label, showBorder = true, ...rest }: FormControlLabelProps) {
  return (
    <StyledFormControlLabel
      {...rest}
      $showBorder={showBorder}
      control={control}
      label={label}
      classes={{ label: 'label' }}
    />
  );
}

const StyledFormControlLabel = styled(MuiFormControlLabel)<FontSizeProps & BackgroundProps & { $showBorder: boolean }>`
  background: ${(props) => {
    // Return grey color if disabled
    if (props.disabled) {
      return theme.colors.greyBackgroundMedium;
    }

    if (props.bg || props.background) {
      return props.bg ?? props.background;
    }

    // Otherwise, primary if checked and white if not
    return props.checked ? props.theme.colors.primary : '#ffffff';
  }};
  border: 1px solid;
  border-color: ${(props) => {
    if (props.$showBorder) {
      return props.checked ? '#ffffff' : props.theme.colors.secondaryLight;
    }
    return 'transparent';
  }};
  box-sizing: border-box;
  border-radius: 5px;
  margin-left: 0 !important;
  margin-right: 0 !important;

  ${maxWidth};
  ${maxHeight};
  ${height};
  ${width};

  transition:
    background-color 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  & .label {
    color: ${(props) => {
      if (props.color) {
        return props.color;
      }
      return props.checked ? '#ffffff' : props.theme.colors.secondaryDark;
    }};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 10px;
    text-align: left;
  }
`;
